import React, { useState } from 'react';

const GlobalKnowledgeLayer = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = ['overview', 'signals', 'patterns', 'settings'];

  return (
    <div style={{padding:'20px'}}>
      <h2 style={{color:'#7c3aed',marginBottom:'4px'}}>🧠 Global Knowledge Layer</h2>
      <p style={{color:'#64748b',marginBottom:'24px',fontSize:'13px'}}>
        Aetheris Collective Intelligence Layer — federated learning across all tenants
      </p>

      {/* Tabs */}
      <div style={{display:'flex',gap:'8px',marginBottom:'24px',borderBottom:'1px solid #334155',paddingBottom:'0'}}>
        {tabs.map(tab => (
          <button key={tab} onClick={() => setActiveTab(tab)} style={{
            background:'transparent',border:'none',
            borderBottom: activeTab === tab ? '2px solid #7c3aed' : '2px solid transparent',
            color: activeTab === tab ? '#7c3aed' : '#64748b',
            padding:'8px 16px',cursor:'pointer',fontSize:'14px',
            textTransform:'capitalize',fontWeight: activeTab === tab ? 'bold' : 'normal'
          }}>{tab}</button>
        ))}
      </div>

      {activeTab === 'overview' && (
        <div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'16px',marginBottom:'24px'}}>
            {[
              {label:'Participating Tenants', value:'1', color:'#7c3aed'},
              {label:'Signals Collected', value:'0', color:'#34d399'},
              {label:'Global Patterns', value:'0', color:'#3b82f6'},
            ].map(m => (
              <div key={m.label} style={{background:'#1e293b',borderRadius:'12px',padding:'20px',border:'1px solid #334155'}}>
                <div style={{color:'#64748b',fontSize:'12px',marginBottom:'8px'}}>{m.label}</div>
                <div style={{color:m.color,fontSize:'32px',fontWeight:'bold'}}>{m.value}</div>
              </div>
            ))}
          </div>

          <div style={{background:'#1e293b',borderRadius:'12px',padding:'24px',border:'1px solid #334155',marginBottom:'16px'}}>
            <h3 style={{color:'#e2e8f0',marginBottom:'16px'}}>📋 Architecture</h3>
            <div style={{color:'#94a3b8',fontSize:'14px',lineHeight:'1.8'}}>
              <p>The Global Knowledge Layer operates on a <strong style={{color:'#7c3aed'}}>federated, edge-powered</strong> model:</p>
              <ul style={{paddingLeft:'20px'}}>
                <li><strong style={{color:'#34d399'}}>Edge Compute</strong> — Each tenant processes data locally, sending only anonymized micro-signals (2-5 KB)</li>
                <li><strong style={{color:'#3b82f6'}}>K-Anonymity</strong> — All signals are aggregated with privacy thresholds before storage</li>
                <li><strong style={{color:'#f59e0b'}}>Protected Projects</strong> — Tenant IP is automatically filtered before contribution</li>
                <li><strong style={{color:'#7c3aed'}}>Global Patterns</strong> — Aggregated insights are published back to all participating tenants</li>
              </ul>
            </div>
          </div>

          <div style={{background:'rgba(124,58,237,0.1)',borderRadius:'12px',padding:'20px',border:'1px solid rgba(124,58,237,0.3)'}}>
            <div style={{color:'#7c3aed',fontWeight:'bold',marginBottom:'8px'}}>🚧 In Development</div>
            <p style={{color:'#94a3b8',margin:0,fontSize:'13px'}}>
              The signal collection and aggregation pipeline is being built. 
              This will enable cross-tenant learning while maintaining complete tenant privacy.
            </p>
          </div>
        </div>
      )}

      {activeTab === 'signals' && (
        <div style={{textAlign:'center',padding:'60px',color:'#64748b'}}>
          <div style={{fontSize:'48px',marginBottom:'16px'}}>📡</div>
          <p>No signals collected yet. Signal collection begins when tenants opt-in to the In-Kind Federation.</p>
        </div>
      )}

      {activeTab === 'patterns' && (
        <div style={{textAlign:'center',padding:'60px',color:'#64748b'}}>
          <div style={{fontSize:'48px',marginBottom:'16px'}}>🔮</div>
          <p>No global patterns discovered yet. Patterns emerge as more tenants contribute signals.</p>
        </div>
      )}

      {activeTab === 'settings' && (
        <div>
          <div style={{background:'#1e293b',borderRadius:'12px',padding:'20px',border:'1px solid #334155',marginBottom:'16px'}}>
            <h3 style={{color:'#e2e8f0',marginBottom:'16px'}}>Federation Settings</h3>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 0',borderBottom:'1px solid #1e293b'}}>
              <div>
                <div style={{color:'#e2e8f0',fontSize:'14px'}}>Require opt-in for participation</div>
                <div style={{color:'#64748b',fontSize:'12px'}}>Tenants must explicitly join the federation</div>
              </div>
              <div style={{background:'#34d399',width:'40px',height:'20px',borderRadius:'10px',cursor:'pointer'}}></div>
            </div>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 0',borderBottom:'1px solid #1e293b'}}>
              <div>
                <div style={{color:'#e2e8f0',fontSize:'14px'}}>K-anonymity threshold</div>
                <div style={{color:'#64748b',fontSize:'12px'}}>Minimum tenants required before publishing a pattern</div>
              </div>
              <div style={{color:'#7c3aed',fontWeight:'bold'}}>5</div>
            </div>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 0'}}>
              <div>
                <div style={{color:'#e2e8f0',fontSize:'14px'}}>Signal retention window</div>
                <div style={{color:'#64748b',fontSize:'12px'}}>How long raw signals are kept before deletion</div>
              </div>
              <div style={{color:'#7c3aed',fontWeight:'bold'}}>90 days</div>
            </div>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 0',borderTop:'1px solid #334155'}}>
              <div>
                <div style={{color:'#e2e8f0',fontSize:'14px'}}>Pattern retention</div>
                <div style={{color:'#64748b',fontSize:'12px'}}>Global patterns are kept indefinitely unless superseded</div>
              </div>
              <div style={{color:'#34d399',fontWeight:'bold'}}>Permanent</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GlobalKnowledgeLayer;
